import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppRouter } from '@/app/router';
import { initObservability } from '@/shared/observability';

import './index.css';

// Before anything renders: a crash while mounting must be reported too.
initObservability();

const container = document.getElementById('root');
if (!container) {
  throw new Error('No se ha encontrado el elemento #root');
}

createRoot(container).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
